<div data-automation="comGroupedOfferHoursPanel">
    <!--- CREATE/EDIT --->
    <div *ngIf="(isCreateMode || isEditMode)" class="panel-content">
      <app-time-range-slider [mode]="mode" [locale]="locale" [frm]="frm" [offerGroups]="offerGroups" (groupsChanged)="onGroupsChanged($event)"></app-time-range-slider>
    </div>

    <!--- VIEW --->
    <div *ngIf="isViewMode" class="panel-content">
      <div class="form-group">
        <app-time-range-slider [mode]="mode" [locale]="locale" [offerGroups]="offerGroups"></app-time-range-slider>
      </div>
    </div>
</div>